import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { OverflowActions } from '@guryou/html-components';

// The actions zone specifically collapses beyond 2 buttons into a "⋮" overflow menu —
// applied here (the one portal every action button ultimately goes through, whether a
// page imports this directly or via the HeaderActions convenience wrapper) so it's
// never something each page has to opt into separately.
const ACTIONS_TARGET_ID = 'admin-header-actions';

const AdminHeaderPortal = ({ children, targetId = ACTIONS_TARGET_ID }) => {
  const [targetNode, setTargetNode] = useState(document.getElementById(targetId));

  useEffect(() => {
    const node = document.getElementById(targetId);
    if (node) {
      setTargetNode(node);
      return;
    }

    const observer = new MutationObserver(() => {
      const newNode = document.getElementById(targetId);
      if (newNode) {
        setTargetNode(newNode);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [targetId]);

  if (!targetNode || !children) {
    return null;
  }

  const content = targetId === ACTIONS_TARGET_ID ? <OverflowActions>{children}</OverflowActions> : children;

  return createPortal(content, targetNode);
};

export default AdminHeaderPortal;
